/**
 * Serviço para obter a chave da API do Google Maps
 */
import { useApi } from '@/utils/axios';
import { MAPS_ROTAS } from '@/utils/apiRoutes';

// Cache para as chaves da API - evita múltiplas requisições
let cachedApiKeys = null;

/**
 * Busca as chaves da API do Google Maps do servidor
 * @returns {Promise<string[]>} Chaves da API
 */
export const getGoogleApiKeys = async () => {
  // Se já tivermos as chaves em cache, retorna imediatamente
  if (cachedApiKeys) {
    return cachedApiKeys;
  }

  try {
    const response = await useApi(MAPS_ROTAS.CHAVE_GOOGLE).fetch();

    // assume agora response.data.chaves é um array de strings
    if (response?.success && Array.isArray(response.data.chaves)) {
      cachedApiKeys = response.data.chaves.sort(() => Math.random() - 0.5);

      return cachedApiKeys;
    }
    // fallback caso volte só uma chave
    if (response?.success && response?.data?.chave) {
      cachedApiKeys = [response.data.chave];
      return cachedApiKeys;
    }
    throw new Error('Formato de resposta inválido');
  } catch (error) {
    throw error;
  }
};

export default {
  getGoogleApiKeys
};
